import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-externaluserhome',
  templateUrl: './externaluserhome.component.html',
  styleUrls: ['./externaluserhome.component.css']
})
export class ExternaluserhomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.localStorage.clear();
  }

}



// WEBPACK FOOTER //
// ./src/app/home/externaluserhome/externaluserhome.component.ts